export const COURSES_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    program_name: "",
    program_value: "",
    erp_unicode: "",
    pok: "",
    priority: 0,
    brochure: "",
    is_certification: false,
  },

  COURSES_FIELDS_CONFIG: [
    {
      fieldName: "program_name",
      label: "Program Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Program Name",
      required: true,
      defaultValue: "",
    },
    // {
    //   fieldName: "program_value",
    //   label: "Program Value",
    //   value: "",
    //   valueType: "string",
    //   filedType: "INPUT",
    //   placeholder: "Enter Program Value",
    //   defaultValue: "",
    // },
    {
      fieldName: "erp_unicode",
      label: "ERP Unicode",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter ERP Unicode",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "pok",
      label: "POK",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter POK",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "priority",
      label: "Priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: false,
      defaultValue: 0,
    },
    {
      fieldName: "brochure",
      label: "Brochure",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Brochure",
      required: false,
      defaultValue: "",
    },
    // Certification programme. Off = the lead form runs its regular single-step
    // flow for this course; on = the multi-step flow. Stored on the course row,
    // so the flag travels with the Area of Interest the user picks.
    {
      fieldName: "is_certification",
      label: "Certification Programme",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Run the multi-step lead form for this course",
      required: false,
      defaultValue: false,
    },
    // The LMS batch a learner on this programme is enrolled into. Only used by
    // the certification flow; leaving it blank skips LMS provisioning for this
    // course, and the learner is told their credentials will be emailed.
    {
      fieldName: "lms_program_batch_id",
      label: "LMS Program Batch ID",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Batch id from the LMS team — required to create LMS logins",
      required: false,
      defaultValue: "",
    },
    // {
    //   fieldName: "pok",
    //   label: "POK (appended to the lead form/popup 8 redirect URL)",
    //   value: "",
    //   valueType: "string",
    //   filedType: "INPUT",
    //   placeholder: "Enter POK",
    //   required: false,
    //   defaultValue: "",
    // },
  ],

  // Tree configuration for flat list (no parent-child structure)
  TREE_CONFIG: {
    treeTitle: "Courses",
    treeIcon: "📚",
    emptyMessage: "No courses yet. Add your first one below.",
    itemDisplayFields: {
      primary: "program_name",
      // secondary: "program_value",
      statusField: null, // No status field
      statusInactiveLabel: "",
      childrenField: null, // No children
    },
    fieldMappings: {
      id: "id",
      parentId: null, // No parent
      orderIndex: "priority",
      title: "program_name",
    },
    parentFieldName: null, // No parent field
    formLabels: {
      addNew: "➕ Add New Course",
      edit: "✏️ Edit Course",
      saveButton: "Add Course",
      updateButton: "Update Course",
      newButton: "New",
      cancelButton: "Cancel",
    },
    deleteConfirmation: (item: any) => `Delete "${item.program_name}"?`,
    requiresParentComponent: false, // No parent component needed
    hasParentChildStructure: false, // No tree structure
  },

  SUCCESS_MESSAGE: "Course saved successfully",
  ERROR_MESSAGE: "Failed to save course",
  SAVE_BUTTON_TEXT: "Save Course",
  SAVING_BUTTON_TEXT: "Saving...",
  VALIDATION_ERROR_TITLE: "Validation Error",
  VALIDATION_ERROR_DESCRIPTION: "Please fill in all required fields",
  CONFIG_NOT_FOUND_ERROR: "Course configuration not found",
  UPDATE_METHOD_NOT_CONFIGURED_ERROR: "Update method not configured for course",
  COURSE_ID_REQUIRED_ERROR: "Course ID is required for update",
};

